// Copyright ©️ 2026 eVolve MEP, LLC

/** Returns the proper `autoFocus` props for an `Input` field if `condition` is met. */
export const autofocusIf = (condition: boolean) => (condition ? { autoFocus: true, ['data-autofocus']: true } : {});

/**
 * Focuses the first `[data-autofocus]` / `[autofocus]` element inside `containerSelector`.
 * Call from a modal/popover/drawer `onEntered` so focus lands after the open transition.
 */
export const focusAutoFocusElement = (containerSelector: string) => {
  const autofocusElement = document.querySelector(
    `${containerSelector} [data-autofocus], ${containerSelector} [autofocus]`,
  ) as HTMLElement | null;
  autofocusElement?.focus();
};

/**
 * Divider between a modal's header, body, and footer.
 *
 * Exported here to avoid an import cycle since it's used in both `WrappedModal` and `ModalButtons`
 **/
export const MODAL_DIVIDER_BORDER = '1px solid var(--mantine-color-gray-3)';
